// pl_pms_common.ts
// Elementy wspólne dla wszystkich ekranów PMS — statusy, akcje, etykiety
// Importuj ten plik w każdym ekranowym pliku tłumaczeń zamiast powielać te same klucze.

export const plPmsCommon = {

  // ── Statusy pokoi ──────────────────────────────────────────────────────────
  roomStatus: {
    available:    "Dostępny",
    occupied:     "Zajęty",
    dirty:        "Brudny",
    clean:        "Czysty",
    cleaning:     "W sprzątaniu",
    inspected:    "Skontrolowany",
    blocked:      "Zablokowany",
    outOfOrder:   "Wyłączony z użytku",
    outOfService: "Poza służbą",
    unassigned:   "Nieprzypisany",
    reserved:     "Zarezerwowany",
    maintenance:  "W konserwacji",
  },

  // ── Statusy rezerwacji ─────────────────────────────────────────────────────
  reservationStatus: {
    confirmed:  "Potwierdzona",
    inHouse:    "Zameldowany",
    cancelled:  "Anulowana",
    checkedOut: "Wymeldowany",
    noShow:     "Nieobecny",
    waitlist:   "Lista oczekujących",
    pending:    "Oczekująca",
    planned:    "Planowana",
    completed:  "Zakończona",
    booked:     "Zarezerwowana",
    active:     "Aktywna",
    all:        "Wszystkie",
  },

  roomCalendar: {
    allTypes: "Wszystkie typy",
    allFloors: "Wszystkie piętra",
    floor: "Piętro {{floor}}",
    filterByFloor: "Filtruj według piętra",
    clearFilters: "Wyczyść",
    checkedOut: "Wymeldowane",
    checkedIn: "Zameldowane",
    cancelledNoShow: "Anulowane / Nieprzybyłe",
    showCheckedOut: "Pokaż wymeldowane rezerwacje",
    hideCheckedOut: "Ukryj wymeldowane rezerwacje",
    reservationLegend: "Legenda statusów rezerwacji i filtr pokoi",
    roomNumberPlaceholder: "Nr pokoju",
    searchRoomNumber: "Wyszukaj numer pokoju",
  },

  // ── Ważność / Priorytet ────────────────────────────────────────────────────
  severity: {
    critical: "Krytyczny",
    high:     "Wysoki",
    medium:   "Średni",
    low:      "Niski",
  },

  // ── Przyciski i akcje ──────────────────────────────────────────────────────
  actions: {
    save:        "Zapisz",
    saving:      "Zapisywanie...",
    cancel:      "Anuluj",
    cancelling:  "Anulowanie...",
    close:       "Zamknij",
    closing:     "Zamykanie...",
    edit:        "Edytuj",
    delete:      "Usuń",
    confirm:     "Potwierdź",
    approve:     "Zatwierdź",
    create:      "Utwórz",
    creating:    "Tworzenie...",
    add:         "Dodaj",
    adding:      "Dodawanie...",
    back:        "Wstecz",
    search:      "Szukaj",
    filter:      "Filtruj",
    refresh:     "Odśwież",
    download:    "Pobierz",
    preview:     "Podgląd",
    print:       "Drukuj",
    send:        "Wyślij",
    modify:      "Modyfikuj",
    viewAll:     "Zobacz wszystko",
    viewDetails: "Zobacz szczegóły",
    opening:     "Otwieranie...",
    set:         "Ustaw",
  },

  // ── Stany komunikatów ──────────────────────────────────────────────────────
  state: {
    loading:   "Ładowanie...",
    noData:    "Brak danych",
    noResults: "Brak wyników",
    failed:    "Nieudane.",
  },

  // ── Wspólne etykiety pól ───────────────────────────────────────────────────
  labels: {
    guest:        "Gość",
    guests:       "Goście",
    room:         "Pokój",
    rooms:        "Pokoje",
    floor:        "Piętro",
    night:        "Noc",
    nights:       "Noce",
    checkIn:      "Zameldowanie",
    checkOut:     "Wymeldowanie",
    arrival:      "Przyjazd",
    departure:    "Odjazd",
    arrivals:     "Przyjazdy",
    departures:   "Odjazdy",
    status:       "Status",
    operations:   "Operacje",
    frontDesk:    "Recepcja",
    occupancy:    "Obłożenie",
    revenue:      "Przychód",
    billing:      "Rozliczenia",
    housekeeping: "Housekeeping",
    department:   "Dział",
    owner:        "Opiekun",
    priority:     "Priorytet",
    date:         "Data",
    time:         "Czas",
    total:        "Łącznie",
    notes:        "Notatki",
    invoice:      "Faktura",
    group:        "Grupa",
    type:         "Typ",
    rate:         "Stawka",
    balance:      "Saldo",
    amount:       "Kwota",
    currency:     "Waluta",
    name:         "Nazwa",
    email:        "Email",
    phone:        "Telefon",
    address:      "Adres",
    country:      "Kraj",
    today:        "Dziś",
    other:        "Inne",
    none:         "Brak",
    unassigned:   "Nieprzypisany",
    inHouse:      "Zameldowani",
    readyRoom:    "Gotowy pokój",
    noReadyRoom:  "Brak gotowego pokoju",
  },

} as const;

export default plPmsCommon;
